import { render } from "./StatePensionViewer.vue?vue&type=template&id=bce599dc&ts=true"
import script from "./StatePensionViewer.vue?vue&type=script&lang=ts"
export * from "./StatePensionViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__